module.exports = __webpack_public_path__ + "img/bfb_we.c7afec08.png";